// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"249":"forgotPassword","884":"admin","915":"Blank","933":"auth","966":"login"}[chunkId] + "." + {"249":"f1a2d371","884":"b5b710cc","915":"2e995e8d","933":"0f71f7dc","966":"1fb9ca37"}[chunkId] + ".css";
};